import moment from 'moment'
import firedux from '../firedux'
import {dispatch} from '../store'

import {
  SCHEDULES_ENDPOINT
} from '../../config/constants'

import setUserSchedule from '../actions/set_user_schedule'

const onUserSchedule = (snapshot) => {
  if (snapshot.exists()) dispatch(setUserSchedule(snapshot.val(), snapshot.key()))
  else dispatch(setUserSchedule({}, snapshot.key()))
}

let ref

export const watchUserSchedule = (uid, startTime = moment().valueOf(), endTime) => {
  if (!uid) return

  if (!endTime) endTime = moment().add(3, 'month').endOf('day').valueOf()

  const ENDPOINT = `${SCHEDULES_ENDPOINT}/${uid}`

  ref = firedux.ref.child(ENDPOINT)
    .orderByPriority().startAt(startTime).endAt(endTime)

  ref.on('value', onUserSchedule)
}

export const unwatchUserSchedule = () => {
  if (!ref) return

  ref.off('value', onUserSchedule)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/schedule.js
 **/